import { useTranslation } from 'react-i18next';
import { useDialogs } from '@cbridge-modules/dialog';

export const useConfirmCancelForm = () => {
  const { t } = useTranslation();
  const dialogs = useDialogs();

  const confirmCloseForm = () => dialogs.confirm(
    t('text:common.dialog.discardChanges.description'),
    {
      title: t('text:common.dialog.discardChanges.title'),
      okText: t('text:common.dialog.discardChanges.discard'),
      cancelText: t('text:common.dialog.discardChanges.keepEditing'),
    },
  );

  return { confirmCloseForm };
};
